<script setup lang="ts">
import { useTranslate } from '@tolgee/vue'

import { PLAN_TYPES } from '@/api/interfaces'
import { useEditorStore } from '@/stores/Editor'
import { useAccountStore } from '@/stores/Account'

import BaseRadioGroup, { type RadioItem } from '@/components/common/BaseRadioGroup.vue'

const editorStore = useEditorStore()
const accountStore = useAccountStore()
const { t } = useTranslate('local')

const items: RadioItem[] = [
  {
    label: t.value(`EditorImpactSettings.style.simple`),
    value: 'simple',
    imageUrl: '/src/assets/images/editor/impact-icon-style-simple.png',
  },
  {
    label: t.value(`EditorImpactSettings.style.flat`),
    value: 'flat',
    imageUrl: '/src/assets/images/editor/impact-icon-style-flat.png',
    planType: PLAN_TYPES.GROWTH,
    disabled: accountStore.hasStarterPlan,
  },
  {
    label: t.value(`EditorImpactSettings.style.isometric`),
    value: 'isometric',
    imageUrl: '/src/assets/images/editor/impact-icon-style-isometric.png',
    planType: PLAN_TYPES.GROWTH,
    disabled: accountStore.hasStarterPlan,
  },
]
</script>

<template>
  <div class="mb-5">
    <BaseRadioGroup v-model="editorStore.editor.icon.style" :items="items" />
  </div>
</template>

<style lang="scss" scoped></style>
